import type { LalSegmentApi, SeedListData } from '@openx/types/segments';

export const mapLalSeedSourceToSeedListData = (lalSegment: Partial<LalSegmentApi>): SeedListData[] => {
  if (!lalSegment?.lookalike_seed_sources) {
    return [];
  }

  return lalSegment.lookalike_seed_sources.map(({ segment }) => ({
    id: segment.id,
    name: segment.name,
    reach: segment.reach ?? 0,
    status: segment.status ?? '',
    expiration_date: segment.expiration_date,
    created: segment.created_date ?? '',
    updated: segment.updated_date ?? '',
    provider: lalSegment.provider?.name ?? '',
    account: lalSegment.account?.name ?? '',
    isOnList: true,
  }));
};
